import i18n from '@/i18n'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import { dateFormat, mobileNumber } from '@/Utils/fliter'

function getBase64ImageFromURL (url) {
  return new Promise((resolve, reject) => {
    var img = new Image()
    img.setAttribute('crossOrigin', 'anonymous')
    img.onload = () => {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      var dataURL = canvas.toDataURL('image/png')
      resolve(dataURL)
    }
    img.onerror = error => {
      reject(error)
    }
    img.src = url
  })
}

const exportPdfDetails = async (reportTitle, data, vm) => {
    try {
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const pdfContent = []
      pdfContent.push({ text: vm.$t('externalUser.profile_details'), style: 'header', decoration: 'underline', alignment: 'center' })
      const allRows = [
        [
          {
            rowSpan: 5,
            stack: [
                {
                  image: data.photo ? await getBase64ImageFromURL(data.photo) : '',
                  fit: [150, 150],
                  alignment: 'center',
                  style: 'td',
                  width: 150,
                  margin: [0, 0, 0, 20]
                }
            ]
          },
          { text: vm.$t('retailerManagement.name'), style: 'td' },
          { text: ':', style: 'td' },
          { text: i18n.locale === 'bn' ? data.contact_person_name_bn : data.contact_person_name_en, style: 'td' }
        ],
        [
          {},
          { text: vm.$t('externalUser.mobile_no'), style: 'td' },
          { text: ':', style: 'td' },
          { text: mobileNumber(data.contact_no), style: 'td' }
        ],
        [
          {},
          { text: vm.$t('globalTrans.email'), style: 'td' },
          { text: ':', style: 'td' },
          { text: data.email, style: 'td' }
        ],
        [
          {},
          { text: vm.$t('externalUser.company_name'), style: 'td' },
          { text: ':', style: 'td' },
          { text: i18n.locale === 'bn' ? data.company_name_bn : data.company_name_en, style: 'td' }
        ],
        [
          {},
          { text: vm.$t('externalUser.established_date'), style: 'td' },
          { text: ':', style: 'td' },
          { text: dateFormat(data.established_date), style: 'td' }
        ]
      ]
      pdfContent.push({
        table: {
          headerRows: 5,
          widths: ['30%', '25%', '5%', '40%'],
          body: allRows
        },
        layout: 'noBorders'
      })
      pdfContent.push({ text: vm.$t('externalUser.address'), style: 'header1', decoration: 'underline', alignment: 'center' })
      const allAddressRows = [
        [
          { text: vm.$t('org_pro.area_type'), style: 'td' },
          { text: vm.getStoreData('wardTypeList', data.area_type_id), style: 'td' },
          { text: vm.$t('retailerManagement.division'), style: 'td' },
          { text: vm.getStoreData('divisionList', data.division_id), style: 'td' }
        ],
        [
          { text: vm.$t('retailerManagement.district'), style: 'td' },
          { text: vm.getStoreData('districtList', data.district_id), style: 'td' },
          { text: data.area_type_id === 1 ? vm.$t('production_service_config.city_corporation_id') : (data.area_type_id === 2 ? vm.$t('org_pro.pauroshoba') : (data.area_type_id === 3 ? vm.$t('retailerManagement.upazilla') : '')), style: 'td' },
          { text: data.area_type_id === 1 ? vm.getStoreData('cityCorporationList', data.city_corporation_id) : (data.area_type_id === 2 ? vm.getStoreData('pauroshobaList', data.paurasabha_id) : (data.area_type_id === 3 ? vm.getStoreData('upazilaList', data.upazilla_id) : '')), style: 'td' }
        ],
        [
          { text: data.area_type_id === 2 ? vm.$t('retailerManagement.upazilla') : (data.area_type_id === 3 ? vm.$t('org_pro_union.union') : ''), style: 'td' },
          { text: data.area_type_id === 2 ? vm.getStoreData('upazilaList', data.upazilla_id) : (data.area_type_id === 3 ? vm.getStoreData('unionList', data.union_id) : ''), style: 'td' },
          { text: vm.$t('org_pro.ward'), style: 'td' },
          { text: vm.getStoreData('wardList', data.ward_id), style: 'td' }
        ],
        [
          { text: vm.$t('externalUser.post_code'), style: 'td' },
          { text: vm.$n(data.post_code, { useGrouping: false }), style: 'td' },
          { text: vm.$t('externalUser.post_office'), style: 'td' },
          { text: data.post_office, style: 'td' }
        ],
        [
          { text: vm.$t('production_service_config.address'), style: 'td' },
          { text: i18n.locale === 'bn' ? data.company_address_bn : data.company_address_en, colSpan: '3', style: 'td' },
          {},
          {}
        ]
      ]
      pdfContent.push({
        table: {
          headerRows: 5,
          widths: ['25%', '25%', '25%', '25%'],
          body: allAddressRows
        }
      })
      var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'potscape',
        styles: {
          header: {
            fontSize: 18,
            margin: [0, 0, 0, 16],
            border: 0
          },
          th: {
            fillColor: '#dee2e6',
            fontSize: 9,
            margin: [11, 5, 11, 5]
          },
          td: {
            fontSize: 12,
            margin: [11, 5, 11, 5],
            border: 0
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          header1: {
            fontSize: 18,
            margin: [10, 20, 10, 16],
            border: 0
          }
        }
      }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
}
export default {
  exportPdfDetails
}
